import React from 'react';
import { Input as AntInput } from 'antd';

function TextArea({ ...rest }) {
  return <AntInput.TextArea {...rest} />;
}

export default TextArea;
